import { createActions } from "reduxsauce";

const { Types, Creators } = createActions(
  {
    getDrupalPreviewContent: ["contentTypeMachineName", "optionObject"],
    getDrupalPreviewContentLoading: null,
    getDrupalPreviewContentSuccess: ["res"],
    getDrupalPreviewContentFailure: ["error"],
  },
  { prefix: "PREVIEW_" }
);

export const PreviewTypes = Types;

export default Creators;
